import angular from 'angular';

import SiteService from './service';
import SitesController from './controller';
import {
  SitesFormController,
  sitesFormDirective
} from './sites_form.directive';

angular.module('generator.sites', ['generator.shared']);

angular
  .module('generator.sites')
  .controller('SitesController', SitesController)
  .controller('SitesFormController', SitesFormController)
  .directive('sitesForm', sitesFormDirective)
  .service('SiteService', SiteService);
